var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-iframe"},[(!_vm.detailInfo.pgoods_body)?_c('div',{staticClass:"list-empty"},[_c('p',[_vm._v("本商品暂无详情")])]):_c('div',{staticClass:"mb-body",domProps:{"innerHTML":_vm._s(_vm.detailInfo.pgoods_body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }